module.exports = __webpack_public_path__ + "img/icon-no-user-place.be596cbe.png";